import { FC } from "react";

const Footer: FC = () => {
    return (
        <footer className="footer ">
            <div className="container" id="footerContainer">
                <div className="row">
                    <div className="col-lg-4 mt-3 mt-lg-2 mb-2">
                        <h5>Get in touch</h5>
                        <div className="row">
                            <div className="col">
                                <nav className="social">
                                    <a
                                        href="https://www.linkedin.com/groups/1913709/"
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    >
                                        <i className="fab fa-linkedin"></i>
                                        <span className="sr-only">
                                            Linkedin
                                        </span>
                                    </a>
                                </nav>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-lg-2 my-2">
                        <h5>Sweco Nederland B.V.</h5>
                        <ul className="list-unstyled">
                            <li>Team GIS</li>
                            <li>
                                <a href="callto:+318000224401">
                                    +31 800 022 44 01
                                </a>
                            </li>
                            <li>
                                <a href="mailto:helpdesk.gis-ict@sweco.nl">
                                    helpdesk.gis-ict@sweco.nl
                                </a>
                            </li>
                        </ul>
                        <ul className="list-unstyled">
                            <li>
                                <address>De Holle Bilt 22</address>
                            </li>
                            <li>
                                <address>3732 HM De Bilt</address>
                            </li>
                            <li>
                                <address>Nederland</address>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="row no-gutters">
                    <div className="col-6 d-flex align-items-end">
                        <p className="text-muted">© Copyright Sweco NL</p>
                    </div>
                    <div className="col-6 d-flex justify-content-end">
                        <div className="logotype logotype-white"></div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
